export const reminders = {
    inactivity: {
        title_one: 'Faz {{count}} dia desde sua última revisão',
        title_other: 'Faz {{count}} dias desde sua última revisão',
        body: 'Abra o Kontto para conferir seu mês, vencimentos e pendências.',
    },
    advanceCharge: {
        bodyCard: '{{amount}} será cobrado amanhã. Toque para revisar.',
        bodyDue: '{{amount}} vence amanhã. Toque para revisar.',
    },
    due: {
        payments_one: '{{count}} pagamento',
        payments_other: '{{count}} pagamentos',
        receipts_one: '{{count}} recebimento',
        receipts_other: '{{count}} recebimentos',
        itemsToPay_one: '{{count}} item para pagar',
        itemsToPay_other: '{{count}} itens para pagar',
        itemsToReceive_one: '{{count}} item para receber',
        itemsToReceive_other: '{{count}} itens para receber',
        titleMixed: 'Hoje: {{payments}} e {{receipts}}',
        titlePay: 'Hoje: {{items}}',
        titleReceive: 'Hoje: {{items}}',
        payLabel: 'Pagar {{amount}}',
        receiveLabel: 'Receber {{amount}}',
    },
    trial: {
        valueTitle: 'Seu relatório tá pronto 📊',
        valueBodyWithCount:
            'Você registrou {{count}} gastos — seu relatório de {{month}} tá pronto, com categorias e PDF. Dá uma olhada.',
        valueBody:
            'Seu relatório de {{month}} tá se montando sozinho: categorias, fluxo de caixa e PDF. Dá uma olhada no que o Pro já preparou.',
        endTitle: 'Seu teste grátis está acabando',
        endBodyWithCount:
            'Avisamos como prometido: faltam {{days}} dias de Kontto Pro grátis. Seus {{count}} gastos de {{month}} já viraram relatório — se não for pra você, cancele na {{store}} e não paga nada.',
        endBody:
            'Faltam {{days}} dias de Kontto Pro grátis. Avisamos como prometido: se não for pra você, cancele na {{store}} e não paga nada.',
        // Vitalício com o teste ou uma assinatura ainda renovando ao lado (ADR 0089, emenda de
        // 01/10/2026): o vitalício não cancela nada sozinho e a loja cobra.
        // Véspera do fim do teste CANCELADO (ADR 0173): a perda concreta + o número real.
        cancelledTitleWithCount: 'Amanhã seu relatório fica bloqueado',
        cancelledBodyWithCount: 'Você já fez {{count}} lançamentos com o Pro. Toque pra continuar com tudo liberado.',
        cancelledTitle: 'Seu Pro acaba amanhã',
        cancelledBody: 'Relatórios, conferência de fatura e o uso sem limite param amanhã. Toque pra continuar com tudo liberado.',
        lifetimeTrialTitle: 'Cancele o teste pra não ser cobrado',
        lifetimeTrialBody:
            'Você já tem o vitalício, mas o teste grátis do plano recorrente segue ativo e a {{store}} vai cobrar em {{date}}. Ele não cancela sozinho: cancele em {{location}}.',
        lifetimePaidTitle: 'Cancele a assinatura pra não pagar de novo',
        lifetimePaidBody:
            'Você já tem o vitalício, mas sua assinatura recorrente renova em {{date}} e a {{store}} vai cobrar. Ela não cancela sozinha: cancele em {{location}}.',
    },
    driveBackup: {
        title: 'Seu backup no Drive parou',
        body: 'Toque para reconectar sua conta Google e voltar a proteger seus dados.',
    },
    activation: {
        title: 'Comece pelo primeiro gasto',
        body: 'Registre 1 gasto de hoje e veja seu Kontto ganhar vida — leva 10 segundos.',
    },
    secondEntry: {
        // 25/09/2026: a pergunta genérica ("Anotou algum gasto hoje?") teve 3 toques em 232
        // agendamentos em 28 dias. O título carrega o pedido sozinho — no Android recolhido
        // só ele e o começo do corpo aparecem.
        title: 'Não pare no primeiro gasto',
        body: 'Anote o de hoje e seu dinheiro começa a se organizar. Leva segundos.',
    },
    backupAlert: {
        // Aviso de dados sem backup (ADR 0091). Fato com data quando existe; nunca ameaça,
        // nunca "sentimos sua falta", nunca desconto. A variante `never` não tem data pra
        // citar e por isso aponta a saída GRÁTIS no corpo — exportar na mão —, não o Pro.
        autoStoppedTitle: 'Seu backup automático parou',
        autoStoppedBody:
            'O último foi em {{date}}. O que você lançou depois disso só existe neste aparelho.',
        staleTitle: 'Sua última cópia é de {{date}}',
        staleBody_one:
            'Você tem {{count}} lançamento guardado só aqui. Se o celular sumir, ele some junto.',
        staleBody_other:
            'Você tem {{count}} lançamentos guardados só aqui. Se o celular sumir, eles somem junto.',
        neverTitle_one: 'Seu {{count}} lançamento só existe aqui',
        neverTitle_other: 'Seus {{count}} lançamentos só existem aqui',
        neverBody: 'Nenhuma cópia de segurança até agora. Dá pra exportar uma agora, em dois toques.',
    },
    // Nomes dos canais de notificação Android (visíveis nas Configurações do sistema).
    channels: {
        activation: 'Primeiros passos',
        inactivity: 'Lembrete de retorno',
        due: 'Lembretes financeiros',
        driveBackup: 'Backup no Drive',
        trial: 'Aviso do teste grátis',
        advanceCharge: 'Avisos de cobrança',
        backupAlert: 'Aviso de backup',
    },
};
